
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "TPN",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/TPN.vue